/** Client-side logger — intentionally silent in all environments. */
export const clientLogger = {
  info: (..._args: unknown[]) => {},
  warn: (..._args: unknown[]) => {},
  error: (..._args: unknown[]) => {},
};
